import React from 'react';
import { Form } from 'antd';
import styled from 'styled-components';
import SqlEditor from './SqlEditor';

const SqlContainer = styled.div`
  margin: 0 28px;
  position: relative;
`;

interface SqlTextBoxProps {
  isView?: boolean;
  placeholder?: string;
}

const SqlTextBox: React.FC<SqlTextBoxProps> = ({
  isView = false,
  placeholder = '-- Enter your SQL query here\nSELECT * FROM events WHERE...',
}) => {
  return (
    <SqlContainer>
      <Form.Item
        name={['definition', 'flow_sql_definition']}
        rules={[
          {
            required: true,
            message: 'Please enter a SQL query',
          },
        ]}
      >
        <SqlEditor isView={isView} placeholder={placeholder} />
      </Form.Item>
    </SqlContainer>
  );
};

export default SqlTextBox;
